module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    attrs: {
      "id": "Achievements"
    }
  }, [(_vm.achievementsData.error) ? _h('div', ["\n        Error code: " + _vm._s(_vm.achievementsData.httpcode) + "\n    "]) : _vm._e(), " ", (!_vm.achievementsData.playerstats.achievements) ? _h('div', ["\n        No achievements for this game.\n    "]) : _vm._e(), " ", _h('div', {
    staticClass: "banner"
  }, [_h('h2', [_vm._s(_vm.gameSchema.game.gameName) + " (" + _vm._s(_vm.progressTotal) + ")"]), " ", _h('a', {
    staticClass: "totop",
    attrs: {
      "href": "#"
    }
  }, ["to top"])]), " ", " ", (_vm.gameSchema.game.availableGameStats.achievements) ? _h('ul', [_vm._l((_vm.gameSchema.game.availableGameStats.achievements), function(achievement) {
    return _h('li', {
      class: {
        'done': _vm.isAchieved(achievement)
      }
    }, [(!_vm.isAchieved(achievement)) ? _h('img', {
      attrs: {
        "src": _vm.apiImage(achievement.icongray),
        "alt": achievement.displayName
      }
    }) : _h('img', {
      attrs: {
        "src": _vm.apiImage(achievement.icon),
        "alt": achievement.displayName
      }
    }), " ", " ", _h('dl', {
      staticClass: "text"
    }, [_h('dt', [_vm._s(achievement.displayName)]), " ", _h('dd', [_vm._s(achievement.description)])])])
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/vue-loader/lib/template-compiler.js?id=data-v-9e0ae2c8!C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayerGameAchievements.vue
// module id = 171
// module chunks = 0